import BaseResponse from '../base.response';

export class LogoutResponse extends BaseResponse {

}


// WEBPACK FOOTER //
// ./src/app/models/kartinatv-responses/client/logout.response.ts